import { resolve, define } from 'acast-www-utils';
import deep from './helpers/deep-compare';
import shallow from './helpers/shallow-compare';

function diff(a, b) {
  if (!b) {
    return a;
  }

  const keys = deep(a, b);
  const result = {};

  keys.forEach(path => define(result, path, resolve(b, path, null)));

  return result;
}

export default {
  deep,
  shallow,
  diff,
};
